"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AcceptGTCU;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function AcceptGTCU(props) {
  const {
    setacceptedGTCU,
    acceptedGTCU,
    showGTCUError,
    setshowGTCUError,
    t,
    Link
  } = props;
  const handleCheck = () => {
    if (acceptedGTCU === false) {
      setshowGTCUError(false);
      setacceptedGTCU(!acceptedGTCU);
    }
    setacceptedGTCU(!acceptedGTCU);
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    name: "acceptedCGU",
    checked: acceptedGTCU,
    onChange: handleCheck
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "span",
    sx: {
      mg: 1
    }
  }, t('welcome.i_accept_gtcu'), ' ', /*#__PURE__*/_react.default.createElement(_material.Link, {
    component: Link,
    to: "/cgu",
    color: "secondary"
  }, /*#__PURE__*/_react.default.createElement("b", null, t('welcome.gtcu'))))), showGTCUError && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "caption",
    color: "red"
  }, t('validations.required_gtcu')));
}